<div class="container">
  <div class="datetime-wrapper">
    <div class="date">{{ now | date:"fullDate" }}</div>
    <div class="time">{{ now | date:"shortTime" }}</div>
  </div>
</div>
